export default __webpack_public_path__ + "static/out-team-desktop-f24577816b7d40cff90667ebddc972ad.png";